export default "__VITE_ASSET__e21d2bba__"